export default __webpack_public_path__ + "static/media/icell_logo_small_trans700x700.8c70a26e.png";